export default "__VITE_PUBLIC_ASSET__cd6f5307__"